<template>
  <div class="cmslist">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item v-for="(item, index) in breadData" :key="index"
          ><a>{{ item.name }}</a></el-breadcrumb-item
        >
      </el-breadcrumb>
      <div class="left_and_right_container">
        <div class="container_left">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="单位简章" name="单位简章">
              <div
                class="container_left_richtext html-data"
                v-html="schoolDetail.content1"
              ></div>
            </el-tab-pane>
            <el-tab-pane label="动态" name="动态">
              <div class="container_left_newslistitem_content">
                <news-list-item
                  specialTagName="最新"
                  v-for="(item, index) in newsListData"
                  :key="index"
                  :NewsItemData="item"
                  @click.native="itemClickFun(item)"
                  class="container_left_newslistitem"
                ></news-list-item>
              </div>
            </el-tab-pane>
            <el-tab-pane label="招生简章" name="招生简章">
              <div
                class="container_left_richtext html-data"
                v-html="schoolDetail.content2"
              ></div>
            </el-tab-pane>
          </el-tabs>
          <el-button
            type="primary"
            round
            class="publish_cms_btn"
            @click="publicNewsFun()"
            v-if="activeName == '动态'"
            >发布</el-button
          >
        </div>
        <div class="container_right">
          <div class="right_content">
            <div class="right_content_title">学校信息</div>
            <div class="right_content_pic">
              <!-- <img
                :src="schoolDetail.pic.url"
                alt=""
                v-if="schoolDetail.pic&&schoolDetail.pic.length>0"
              /> -->
              <img
                :src="schoolDetail.certificatepic&&schoolDetail.certificatepic.length>0?schoolDetail.certificatepic[0].url:''"
              />
            </div>
            <div class="right_content_title">
              {{ schoolDetail.name }}
            </div>
            <div class="right_content_subtitle">
              {{ schoolDetail.content }}
            </div>
            <!-- <div class="right_content_numbers">
              <div class="right_content_numbers_item">
                <div class="right_content_numbers_item_name">学员</div>
                <div class="right_content_numbers_item_val">329</div>
              </div>
              <div class="right_content_numbers_item">
                <div class="right_content_numbers_item_name">童星</div>
                <div class="right_content_numbers_item_val">329</div>
              </div>
              <div class="right_content_numbers_item">
                <div class="right_content_numbers_item_name">导师</div>
                <div class="right_content_numbers_item_val">329</div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NewsListItem from "@/components/listItem/NewsListItem";
export default {
  name: "CmsPosition",
  data() {
    return {
      schoolDetail: [], //学校的详细信息
      newsListData: [],
      breadData: [{ name: "" }],
      activeName: "单位简章",
    };
  },
  components: {
    NewsListItem,
  },
  mounted() {
    this.getSchoolInfo();
    this.getCmsList();
    // this.getStoreBread()

    //处理从详情跳转过来的情况
    if(this.$route.query.isfromdetail){
      this.activeName='动态';
    }
  },
  methods: {
    getUser() {
      let that = this;
      that.$api.post(
        "/api/index/userdata",
        {},
        (r) => {
          // that.user = r.data;
        },
        (r) => {
          // that.$message.error(r.msg);
        }
      );
    },
    publicNewsFun() {
      this.getUser();
      this.$api.get(
        "/api/danwei/isUserByDanweiId",
        { danwei_id: this.$route.query.cmspositionId },
        (res) => {
          this.$router.push({
            path: "/position-publish",
            query: {
              danwei_id: this.$route.query.cmspositionId,
              school_type: JSON.stringify(this.schoolDetail.type),
            },
          });
        },
        (err) => {
          this.$message({type:"error",message:"非机构指定会员，不可发布！"})
          // console.log(err);
        }
      );
    },
    //获取面包屑的内容
    getStoreBread() {
      var that = this;
      if (!this.$route.query.cmspositionId) {
        return;
      }
      that.$api.get(
        "/api/cms/breadList",
        {
          cate_id: this.$route.query.cmspositionId,
        },
        (res) => {
          // this.$message.success("发送成功");
          that.breadData = res.data;
          console.log("that.breadDatthat.breadDat", that.breadData);
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    //tab 点击事件
    handleClick() {},
    //获取单位的详细数据
    getSchoolInfo() {
      var that = this;
      if (!this.$route.query.cmspositionId) {
        that.$message.error("cmspositionId不存在！");
        return;
      }
      that.$api.get(
        "/api/danwei/danweiDetail",
        {
          id: this.$route.query.cmspositionId,
        },
        (res) => {
          // this.$message.success("发送成功");
          // console.log("resres.....", res.data);
          that.schoolDetail = res.data;
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    //获取 文章详情
    getCmsList() {
      var that = this;
      if (!this.$route.query.cmspositionId) {
        that.$message.error("cmspositionId不存在！");
        return;
      }
      that.$api.get(
        "/api/danwei/danweiCmsList",
        {
          danwei_id: this.$route.query.cmspositionId,
          pageNo: 1,
          pageSize: 10,
          status:1
        },
        (res) => {
          // this.$message.success("发送成功");
          // console.log("resres.....", res.data.list);
          that.newsListData = res.data.list;
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    //
    itemClickFun(val) {
      // console.log("item", val);
      this.$router.push({ path: "/cmsdetail", query: { id: val.id,cmspositionId:this.$route.query.cmspositionId } });
    },
  },
};
</script>
<style scoped lang="scss">
.cmslist {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
  padding-bottom: 50px;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  // height: 1235px;
}
.breadcrumb {
  margin: 21px 0 20px 23px;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .container_left {
    width: 910px;
    min-height: 1142px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 40px;
    padding: 16px 45px 0 30px;
    box-sizing: border-box;
    position: relative;
    .container_left_richtext {
      width: 100%;
      box-sizing: border-box;
      * > {
        margin: 0 auto;
      }
    }
    .container_left_newslistitem_content {
      position: default;
      width: 98%;
    }
    .container_left_newslistitem {
      width: 100%;
      margin: 3px;
    }
    .publish_cms_btn {
      position: absolute;
      top: 20px;
      right: 50px;
    }
  }
  .container_right {
    width: 306px;
    .right_content {
      width: 306px;
      height: 398px;
      background: #e5eeff;
      border-radius: 17px;
      box-sizing: border-box;
      padding: 19px 12px 20px 12px;
      .right_content_title {
        height: 28px;
        font-size: 20px;
        font-weight: 500;
        color: #000000;
        line-height: 28px;
      }
      .right_content_pic {
        margin: 21px 0 16px 0;
        width: 282px;
        height: 185px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 5px;
        }
      }
      .right_content_subtitle {
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin: 10px 0 32px 0;
        box-sizing: border-box;
        width: 100%;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .right_content_numbers {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .right_content_numbers_item {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
          display: flex;
          flex-direction: row;
          .right_content_numbers_item_val {
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            margin-left: 4px;
          }
        }
      }
    }
  }
}
//处理tab
/deep/.container_left >>> .el-tabs--card >>> .el-tabs__header {
  border-bottom: 0;
}
/deep/.container_left
  >>> .el-tabs
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav {
  border: 0;
}
/deep/.container_left
  >>> .el-tabs
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav
  >>> .el-tabs__item {
  border-left: 0;
  padding: 0;
  margin-right: 36px;
  font-size: 16px;
  font-weight: 400;
  color: #777777;
  &:hover {
    font-weight: 500;
    color: #333333;
    border-bottom: 2px solid #0091ff;
  }
}
/deep/.container_left
  >>> .el-tabs
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav
  >>> .is-active {
  border-bottom: 2px solid #0091ff;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
</style>


// WEBPACK FOOTER //
// CmsPosition.vue?e5a333e0